{
	"main": {
		"title": "Glider takeoff list",
		"nezakljuceni": "INCOMPLETE FLIGHTS",
		"zakljuceni": "COMPLETED FLIGHTS"
	},
	"table": {
		"reg": "REG.",
		"titleJ": "List of Glider Flights",
		"datum": "DATE",
		"vzlet": "TAKEOFF",
		"pilot": "PILOT",
		"naloga": "TASK",
		"pristanek": "LANDING"
	},
	"labels": {
		"datumOd": "Date FROM:",
		"datumDo": "Date TO:",
		"pilotJ": "Select glider pilot:",
		"instruktor": "Select glider instructor:",
		"registracijaJ": "Select glider registration:",
		"namenJ": "Select purpose:",
		"nalogaJ": "Select glider flight task:",
		"pilotM": "Select tow plane pilot:",
		"registracijaM": "Select tow plane registration:",
		"vzlet": "Select takeoff:",
		"pristanek": "Select landing:",
		"poletanje": "Takeoff:",
		"odklop": "Release:",
		"nezakljucen": "Incomplete flight?",
		"pristanekJ": "Glider landing:",
		"pristanekM": "Tow plane landing:",
		"opomba": "Note"
	},
	"modal": {
		"registracija": "registration",
		"pilot": "pilot",
		"regVleke": "tow reg.:",
		"instruktor": "instructor:",
		"namen": "purpose:",
		"naloga": "task:",
		"casVzleta": "takeoff time:",
		"casOdklopa": "release time:",
		"casPristanka": "landing time:",
		"casLetenja": "flight time:",
		"casVleke": "tow time:",
		"opomba": "note:",
		"datumL": "flight date:",
		"datumV": "entry date:"
	},
	"edit": {
		"titleJ": "GLIDER DATA",
		"regJ": "glider registration:",
		"pilotJ": "glider pilot:",
		"instruktor": "instructor:",
		"namenJ": "glider purpose:",
		"nalogaJ": "glider task:",
		"titleM": "TOW PLANE DATA",
		"pilotM": "tow plane pilot:",
		"regM": "tow plane registration",
		"titleS": "GENERAL DATA",
		"krajV": "takeoff location:",
		"krajP": "landing location:",
		"casV": "takeoff time:",
		"casO": "release time:",
		"casPJ": "glider landing time:",
		"casPM": "tow plane landing time:",
		"opomba": "Note:"
	},
	"modalNL": {
		"title": "Complete selected record",
		"regJ": "registration:",
		"pilotJ": "pilot:",
		"regM": "tow reg.:",
		"instruktor": "instructor",
		"namen": "purpose:",
		"naloga": "task:",
		"casV": "takeoff time:",
		"casO": "release time:",
		"pristanekJ": "Glider landing:",
		"casVL": "tow time:",
		"opomba": "note:",
		"datumL": "flight date:",
		"datumV": "entry date:"
	},
	"buttons": {
		"zakljuciLet": "Finish flight",
		"brisiIzbiro": "Clear selection",
		"urediPodatke": "Edit data",
		"posodobiPodatke": "Update data",
		"izbrisiZapis": "Delete record",
		"csv": "Export to CSV",
		"natisni": "Print",
		"poslji": "Send"
	},
	"data": {
		"title": "Data",
	  	"stPristankov": "No. of landings:",
	  	"stLetov": "No. of flights:",
	  	"casVZraku": "Duration:"
	},
	"obvestila": {
	  "zapisPrihodnost": "The record has a date set in the future. CORRECT the selected date!",
	  "zapisCasPrihodnost": "One or more entries have a time set in the future, check the times!",
	  "zapisCasNapaka": "Record times are incorrect! Check the times again!",
	  "napakaPristanka": "Landing time cannot be before takeoff time!",
	  "zapisPobrisan": "Record successfully deleted",
	  "napakaPrazenPristanek": "Input error, landing time cannot be empty",
	  "posodobitevUspesna": "Update successful",
	  "napakaPosodabljanja": "Error updating data.",
	  "napakaBranja": "Error reading data.",
	  "napakaIzbrisa": "Error deleting data.",
	  "vprasanjeIzbris": "Are you sure you want to delete the record?",
	  "napakaVnosa": "Input error, please check if all fields are filled!",
	  "letZakljucen": "Flight successfully completed.",
	  "letNiZakljucen": "Error completing the flight."
	}

}